/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRoleResponseModel } from '../../models/user-role-response-model';

export interface AssignRole$Params {
  userId: string;
}

export function assignRole(http: HttpClient, rootUrl: string, params: AssignRole$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleResponseModel>> {
  const rb = new RequestBuilder(rootUrl, assignRole.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRoleResponseModel>;
    })
  );
}

assignRole.PATH = '/users/{userId}/roles/{roleName}';
